<template>
  <div class="present">
      <Navbar />
      <div class="row present-content">
          <div class="col-md-8">
                <div class="online-counts">
                    <div class="card count-card is-one-third">
                        <div class="card-body">
                            <p class="card-title">Käyttäjiä paikalla</p>
                            <p class="card-value">{{ $store.state.userCount }}</p>
                        </div>
                    </div>
                    <div class="card count-card is-one-third">
                        <div class="card-body">
                            <p class="card-title">Äänioikeutetut</p>
                            <p class="card-value">{{ $store.state.usersWithVotesCount }}</p>
                        </div>
                    </div>
                    <div class="card count-card is-one-third">
                        <div class="card-body">
                            <p class="card-title">Ilman äänioikeutta</p>
                            <p class="card-value">{{ $store.state.userCount - $store.state.usersWithVotesCount }}</p>
                        </div>
                    </div>
                </div>
                <div class="online-counts">
                    <div class="card count-card is-one-third">
                        <div class="card-body">
                            <p class="card-title">Yritykset</p>
                            <p class="card-value">{{ $store.state.companiesOnline }}</p>
                        </div>
                    </div>
                    <div class="card count-card is-one-third">
                        <div class="card-body">
                            <p class="card-title">Yhdistykset</p>
                            <p class="card-value">{{ $store.state.unionsOnline }}</p>
                        </div>
                    </div>
                    <div class="card count-card is-one-third">
                        <div class="card-body">
                            <p class="card-title">Äänimäärä</p>
                            <p class="card-value">{{ $store.state.currentVotes -  $store.state.cutVotesCount  }}</p>
                        </div>
                    </div>
                </div>
                <div class="online-users">
                    <div class="card online-card">
                        <div class="card-body">
                            <p class="card-title center">Äänioikeutetut ({{ onlineUsersVotes.length }})</p>
                            <span class="badge badge-success" 
                            v-for="user in onlineUsersVotes" :key="user._id">{{ user.firstName }} {{ user.lastName }}</span>
                        </div>
                    </div>
                    <div class="card online-card">
                        <div class="card-body">
                            <p class="card-title center">Ilman ääniä ({{ onlineUsersNoVotes.length }})</p>
                            <span class="badge badge-primary" 
                            v-for="user in onlineUsersNoVotes" :key="user._id">{{ user.firstName }} {{ user.lastName }}</span>
                        </div>
                    </div>
                    <div class="card online-card">
                        <div class="card-body">
                            <p class="card-title center">Ei paikalla ({{ offlineUsers.length }})</p>
                            <span class="badge badge-secondary" 
                            v-for="user in offlineUsers" :key="user._id">{{ user.firstName }} {{ user.lastName }}</span>
                        </div>
                    </div>
                </div>
          </div>
          <div class="col-md-4 present-messages">
              <Chat />
          </div>
      </div>
  </div>
</template>

<script>
import Navbar from '@/components/viewers/Navbar.vue'
import Chat from '@/components/ChatMessages.vue'
import Socket from '@/mixins/socket'
import CreateCSS from '@/mixins/cssCreate'

export default {
    components: { Navbar, Chat },
    mixins: [ Socket, CreateCSS ],
    data() {
        return {
            users: [],
            mandates: []
        }
    },
    mounted() {
        const id = this.$route.params.id;

        this.$store.dispatch('API_CALL', {
            method: "post",
            url: `/users/event-attendees`,
            data: { eventId: id },
            headers: {
                ["x-access-token"]: localStorage.adminToken
            }
        }).then((res) => {
            res.data.forEach(user => {
                user.status = false;
            })

            this.users = res.data;

            this.users.forEach((user) => {
                if(user.mandates) {
                    user.mandates.forEach(mandate => {
                        this.mandates.push(mandate)
                    })
                }
            })

            this.socket.emit("join_event", id);
            this.socket.emit("refresh_statuses");

            this.socket.on("online_users", (users) => {
                this.users.forEach((usr) => {
                    usr.status = false;
                })
                users.forEach((id) => {
                    const i = this.users.findIndex((user) => user._id === id);
                    if(i !== -1) { 
                        this.users[i].status = true;
                    } else {
                        const ii = this.mandates.findIndex()
                    }
                })

            })

            this.$nextTick(() => {
                this.createCSS();
            })
        })

    },
    computed: {
        onlineUsers() {
            const online = this.users.filter((user) => { 
                return user.status === true;
            });
            return online;
        },
        offlineUsers() {
            const offline = this.users.filter((user) => { 
                return !user.status;
            });
            return offline;
        },
        onlineUsersVotes() {
            const users = this.onlineUsers.filter(user => {
                return user.voteCount;
            })

            return users;
        },
        onlineUsersNoVotes() {
            const users = this.onlineUsers.filter(user => {
                return !user.voteCount;
            })

            return users;
        }
    }
}
</script>

<style scoped>
    .is-half { width: calc(50% - 20px); float:left; }
    .is-one-third { width: calc(33% - 20px); float: left; }
    .count-card { text-align: center; margin: 10px; }
    .count-card .card-body {
        padding: 0.9rem 1.25rem;
    }
    .center {
        text-align: center;
    }
    .card-title { 
        text-transform: uppercase;
        font-size: 14px;
        margin-bottom:0.2rem;
    }
    .card-value {
        font-size: 18px;
        font-weight: 600;
        margin:0;
    }
    .present-content {
        padding:20px 40px;
    }
    .online-counts {
        display:flex;
    }
    .online-users {
        padding:10px;
    }
    .present-title {
        text-align: center;
        font-size: 15px;
    }
    .online-card {
        margin-top:1rem;
    }
    .online-card .badge {
        margin: 3px 6px 3px 0;
    }
</style>